import { render } from "./BottomMinView.vue?vue&type=template&id=c80331ce&scoped=true"
const script = {}

import "./BottomMinView.vue?vue&type=style&index=0&id=c80331ce&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c80331ce"]])

export default __exports__